import {AuthService} from '../services/auth.service';

class UnAuthorizedController implements ng.IComponentController {
    static $inject = ['authService'];
    constructor(private authService: AuthService) {
        
    }

}

export const unauthorized = {
    controller : UnAuthorizedController,
    template : require('./index.html')
}; 


// WEBPACK FOOTER //
// ./src/app/authorization/unauthorized/index.ts